"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactToggle = _interopRequireDefault(require("@adsk/alloy-react-toggle"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactTooltip = require("@adsk/alloy-react-tooltip");
var _DropdownField = _interopRequireDefault(require("../DropdownField"));
var _hooks = require("./hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OptionalComponentToggle = _ref => {
  let {
    label,
    default: defaultChecked,
    info,
    name,
    components,
    onChange,
    isToggled,
    readOnly,
    style,
    hasParent,
    caption
  } = _ref;
  const [photosOptions, defaultPhotosValue] = (0, _hooks.usePhotosOptions)({
    name,
    components
  });
  return /*#__PURE__*/_react.default.createElement(Container, {
    style: style
  }, /*#__PURE__*/_react.default.createElement(FieldContainer, null, /*#__PURE__*/_react.default.createElement(LabelContainer, null, /*#__PURE__*/_react.default.createElement(Label, {
    hasParent: hasParent
  }, label), info && /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.InfoPopover, {
    message: info
  })), /*#__PURE__*/_react.default.createElement(_alloyReactToggle.default, {
    name: name,
    onChange: value => onChange({
      enabled: value
    }),
    defaultChecked: defaultChecked,
    checked: isToggled,
    disabled: readOnly,
    "data-testid": "optional-component-toggle"
  })), name === 'photos' && /*#__PURE__*/_react.default.createElement(_DropdownField.default, {
    options: photosOptions,
    selected: defaultPhotosValue,
    onChange: _ref2 => {
      let {
        value
      } = _ref2;
      return onChange({
        enabled: true,
        value
      });
    },
    disabled: !isToggled,
    caption: caption
  }));
};
const LabelContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
const Container = _styledComponents.default.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 0.7em;
  margin-bottom: 0.7em;
  ${_ref3 => {
  let {
    style
  } = _ref3;
  return style;
}}
`;
const FieldContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
const Label = _styledComponents.default.span`
  ${{
  ..._alloyReactTheme.default.typography.labelMedium
}}
  ${_ref4 => {
  let {
    hasParent
  } = _ref4;
  return hasParent && 'margin-left: 1.5em';
}}
`;
OptionalComponentToggle.propTypes = {
  label: _propTypes.default.string.isRequired,
  default: _propTypes.default.bool.isRequired,
  name: _propTypes.default.string.isRequired,
  info: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  components: _propTypes.default.object,
  isToggled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  style: _propTypes.default.object,
  hasParent: _propTypes.default.bool,
  caption: _propTypes.default.object
};
var _default = exports.default = OptionalComponentToggle;